module.exports = __webpack_public_path__ + "../resources/img/ic_re_no5_p2_line_wh.3cb0fc79.svg";